import React from 'react';
import './Stack.css';

export type WxbStackGap = 'none' | 'xs' | 'sm' | 'md' | 'lg' | 'xl';
export type WxbStackAlign = 'start' | 'center' | 'end' | 'stretch' | 'baseline';
export type WxbStackJustify = 'start' | 'center' | 'end' | 'between' | 'around';

interface WxbStackBaseProps extends React.HTMLAttributes<HTMLDivElement> {
  gap?: WxbStackGap;
  align?: WxbStackAlign;
  justify?: WxbStackJustify;
  fullWidth?: boolean;
}

export interface WxbStackProps extends WxbStackBaseProps {}

export interface WxbInlineProps extends WxbStackBaseProps {
  wrap?: boolean;
}

const joinClasses = (...classes: Array<string | false | undefined>) =>
  classes.filter(Boolean).join(' ');

export const WxbStack: React.FC<WxbStackProps> = ({
  gap = 'md',
  align = 'stretch',
  justify = 'start',
  fullWidth = false,
  className = '',
  children,
  ...props
}) => (
  <div
    className={joinClasses(
      'wxb-stack',
      `wxb-stack-gap-${gap}`,
      `wxb-stack-align-${align}`,
      `wxb-stack-justify-${justify}`,
      fullWidth && 'wxb-stack-full',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export const WxbInline: React.FC<WxbInlineProps> = ({
  gap = 'md',
  align = 'center',
  justify = 'start',
  fullWidth = false,
  wrap = true,
  className = '',
  children,
  ...props
}) => (
  <div
    className={joinClasses(
      'wxb-inline',
      `wxb-stack-gap-${gap}`,
      `wxb-stack-align-${align}`,
      `wxb-stack-justify-${justify}`,
      fullWidth && 'wxb-stack-full',
      wrap && 'wxb-inline-wrap',
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

